/* eslint-disable no-restricted-imports */
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import GameFrame from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameBody/GameFrame';
import useShowNoFunModeMessage from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameBody/hooks/useShowNoFunModeMessage';
import NoFunModeMessage from '~/client/components/Game/GameView/GameViewDesktop/GameBlock/GameBody/NoFunModeMessage';
import useIngameCurrencyRules from '~/client/components/Game/hooks/useIngameCurrencyRules';
import classNames from '@/external/classNames';
import Img from '@/shared/components/Img';

type Props = {
  isDesktop?: boolean;
};

const GameBody: FC<Props> = ({ isDesktop }) => {
  const { game, gameSession } = useGameContext();
  const showNoFunModeMessage = useShowNoFunModeMessage();
  const { isGameLoadingDisabled } = useIngameCurrencyRules();
  const showGameIframe =
    !isGameLoadingDisabled && !showNoFunModeMessage && gameSession;

  return (
    <div
      className={classNames(
        'relative w-full overflow-hidden bg-popo grow',
        isDesktop && 'sm:rounded-moon-s-sm sm:pb-[56.3%]',
      )}
      style={{ backgroundColor: game?.bgColor }}
    >
      <Img
        src={game?.bgImg || ''}
        alt={game?.handle || ''}
        width={isDesktop ? 1130 : 300}
        height={634}
        fit={isDesktop ? undefined : 'crop'}
        className="absolute h-full w-full"
      />
      {showNoFunModeMessage && <NoFunModeMessage />}
      {showGameIframe && <GameFrame />}
    </div>
  );
};

export default GameBody;
